/**
 * Entry point. Initializes composition and runs LoadProgress.
 */

import "./adapters/hud/hud-styles.css";
import { createComposition } from "./composition.js";
import { t, onLocaleChange, setI18nCampaign } from "./i18n/index.js";
import {
  activeCampaign,
  campaigns,
  shouldShowCampaignSelector,
  type CampaignConfig,
} from "./campaign/index.js";

const currentLocation =
  typeof globalThis.location === "undefined"
    ? undefined
    : { pathname: globalThis.location.pathname, search: globalThis.location.search };

setI18nCampaign(activeCampaign.id as Parameters<typeof setI18nCampaign>[0]);

function campaignHref(campaign: CampaignConfig): string {
  return `?campaign=${encodeURIComponent(campaign.id)}`;
}

function campaignBlurb(campaign: CampaignConfig): string {
  if (campaign.id === "engine") return "Базовый скин движка: проверка правил без лора.";
  if (campaign.id === "engine-v2") return "Обновлённая версия движка v2: Modern UI и неоновые акценты.";
  if (campaign.id === "buddha") return "Колесо, карма и рубежи тишины.";
  return "Реликвии, разломы и святые земли.";
}

function renderCampaignSelector(mountTarget: HTMLElement): void {
  document.title = "Choose Campaign";
  mountTarget.classList.add("campaign-select");
  mountTarget.replaceChildren();

  const shell = document.createElement("main");
  shell.className = "campaign-select__shell";

  const heading = document.createElement("header");
  heading.className = "campaign-select__header";
  const title = document.createElement("h1");
  title.textContent = "Выбор кампании";
  const subtitle = document.createElement("p");
  subtitle.textContent = "Один движок, разные миры. Выбирай, где сегодня держать рубеж.";
  heading.append(title, subtitle);

  const grid = document.createElement("section");
  grid.className = "campaign-select__grid";
  for (const campaign of Object.values(campaigns)) {
    const card = document.createElement("a");
    card.className = "campaign-select__card";
    card.href = campaignHref(campaign);
    card.style.setProperty("--campaign-bg", `url("${campaign.visual.map.backgroundSrc}")`);

    const name = document.createElement("span");
    name.className = "campaign-select__title";
    name.textContent = campaign.title;

    const blurb = document.createElement("span");
    blurb.className = "campaign-select__blurb";
    blurb.textContent = campaignBlurb(campaign);

    const action = document.createElement("span");
    action.className = "campaign-select__action";
    action.textContent = "Играть";

    card.append(name, blurb, action);
    grid.append(card);
  }

  shell.append(heading, grid);
  mountTarget.append(shell);
}

document.title = shouldShowCampaignSelector(currentLocation) ? "Choose Campaign" : activeCampaign.title;

const app = document.querySelector<HTMLDivElement>("#app");
if (app) {
  if (shouldShowCampaignSelector(currentLocation)) {
    renderCampaignSelector(app);
  } else {
    const composition = createComposition({ mountTarget: app, campaign: activeCampaign });
    composition.run();
  }
}

// Portrait overlay i18n: sync text on load and on every locale change.
const rotateText = document.getElementById("rotate-device-text");
function updateRotateText(): void {
  if (rotateText) rotateText.textContent = t("mobile.rotateDevice");
}
updateRotateText();
onLocaleChange(updateRotateText);
